import { mutator } from 'satcheljs';
import {
    type SET_SELECTION_ON_ROWActionMessage,
    setSelectionOnRow,
} from 'owa-mail-actions/lib/setSelectionOnRow';
import getListViewStore from 'owa-mail-list-store/lib/store/Store';

const defaultExport: (actionMessage: SET_SELECTION_ON_ROWActionMessage) => void = mutator(
    setSelectionOnRow,
    actionMessage => {
        const { rowKey, tableViewId, shouldSelect } = actionMessage;
        const tableView = getListViewStore().tableViews.get(tableViewId);
        if (!tableView) {
            return;
        }

        if (shouldSelect) {
            tableView.selectedRowKeys.set(rowKey, true);
        } else {
            tableView.selectedRowKeys.delete(rowKey);
        }
    }
);
export default defaultExport;
